module.exports = __webpack_public_path__ + "img/22072301.ba4e5f80.jpg";